module.exports = __webpack_public_path__ + "img/m12.37fcfb8c.png";